module.exports = __webpack_public_path__ + "static/media/customer_point_white.916b88f3.svg";